// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1crxK","inputWrap":"styles_inputWrap__2y1Su","input":"styles_input__321Zi"};